import React from "react";
import "./skills.css";
import ProgrammingAndLibraries from "./PandL";
import ToolsAndVisualization from "./TandV";
import DataSkills from "./DS";
import SoftSkills from "./SS";

const Skills = () => {
  return (
    <section className="skills section" id="skills">
      <h2 className="section__title">Skills</h2>
      <span className="section__subtitle">Technical & Professional Skills</span>
      <div className="skills__container container grid">
        <ProgrammingAndLibraries />
        <ToolsAndVisualization />
        <DataSkills />
        <SoftSkills />
      </div>
    </section>
  );
};

export default Skills;
